const { gql } = require('graphql-tag');
const utilities = require('../utilities');

('use strict');

var _parent = {};
let log = false;

var notifications = {
    init: p => (_parent = p),

    get: (variables = null) =>
    _parent.gql.query(
      gql`
        query getNotification${_parent.gql.buildVariablesDeclarationString('notifications', variables)} {
          notifications${_parent.gql.buildWhereClauseString(variables)} {
            ...Notification
          }
        }
        ${_parent.fragments.notification()}
      `
    ),

    deleteById: id =>
    _parent.gql.mutation(
      gql`
      mutation delete_notification($id: bigint!) {
        delete_notifications(where: { id: { _eq: $id } }) {
          affected_rows
          returning {
            ...Notification
          }
        }
      }
        ${_parent.fragments.notification()}
      `,
      { id: id }
    ),

    deleteExpired: deleteDate => 
        _parent.gql.mutation(
            gql`
            mutation deleteExpiredNotifications($deleteDate: timestamptz!) {
                delete_notifications(where: 
                  {_or: [
                    {
                      type: {_eq: "action"}, 
                      createdat: {_lt: $deleteDate}, 
                      resolvedby: {_neq: "null"}, 
                      assignedto: {_neq: "null"}
                    }, 
                    {
                      type: {_eq: "inform"}, 
                      createdat: {_lt: $deleteDate}
                    }
                  ]}
                ) {
                  affected_rows
                  returning {
                    id
                  }
                }
              }
              `,
              { deleteDate: deleteDate }
        ),
    

   create: notification =>
   //to do at validation
   _parent.gql.mutation(
     gql`
     mutation add_notification(
        $type: String!,
        $title: String!,
        $body: String!,
        $createdby: String!
        $assignedto: String,
        $assignedby: String,
        $assignedat: timestamptz,
        $duedate: timestamptz,
        $notes: String
        $json: jsonb
      ) {
        insert_notifications(objects: {
            type: $type, 
            title: $title, 
            body: $body,  
            createdby: $createdby,
            assignedto: $assignedto,
            assignedby: $assignedby,
            assignedat: $assignedat,
            duedate: $duedate
            notes: $notes
            json: $json
        }) {
          affected_rows
          returning {
            ...Notification
          }
        }
      }
       ${_parent.fragments.notification()}
     `,
     {type: notification.type, title: notification.title, body: notification.body, createdby: notification.createdby, assignedby: notification.assignedby, assignedto: notification.assignedto, assignedat: notification.assignedat, duedate:notification.duedate, notes: notification.notes, json: notification.json}
   ),
};

module.exports = notifications;